/** Distribution run statuses as the API returns them (DistributionRunStatus). */
export enum DistributionStatus {
  DRAFT = 'DRAFT',
  READY = 'READY',
  APPROVED = 'APPROVED',
  FINALIZED = 'FINALIZED',
  VOID = 'VOID',
}

export interface DistributionModel {
  id: number;
  periodStart: string;
  periodEnd: string;
  grossCollected: number;
  status: DistributionStatus;
  createdAt: string;
  label?: string;
}

export interface DistributionSubReport {
  id: number;
  name: string;
  distributionId: number;
}

export interface DistributionDetailModel extends DistributionModel {
  subReports: DistributionSubReport[];
}

// ---- New distribution engine API (GET/POST /api/distributions) ----

export type DistributionRunStatus = 'DRAFT' | 'READY' | 'APPROVED' | 'FINALIZED' | 'VOID';

export interface DistributionLine {
  id: number;
  jurisdictionId: number;
  jurisdictionName: string;
  startDate: string;
  endDate: string;
  grossReceipts: number;
  exemptReceipts: number;
  taxableReceipts: number;
  totalTaxCollected: number;
  sumOverShort: number;
  sumAllowance: number;
  sumProcessingFee: number;
  sumOtherFees: number;
  sumCollectionCommission: number;
  sumAdjustmentAmount: number;
  sumPenaltyAmount: number;
  sumInterestAmount: number;
  totalAmountRemitted: number;
  distributionAmount: number;
}

export interface DistributionRun {
  id: number;
  periodLabel: string;
  startDate: string;
  endDate: string;
  status: DistributionRunStatus;
  totalToDistribute: number;
  generatedAt?: string;
  generatedBy?: string;
  approvedAt?: string;
  approvedBy?: string;
  finalizedAt?: string;
  finalizedBy?: string;
  lines: DistributionLine[];
}

export interface GenerateDistributionRequest {
  startDate: string;
  endDate: string;
  periodLabel: string;
}

export interface Jurisdiction {
  id: number;
  code: string;
  name: string;
  commissionRate: number;
  active: boolean;
}
